
import template from './ko-field-view-text.html';

class TextComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);
	}
}


export default {
	name: 'ko-field-view-text',
	viewModel: TextComponentVM,
	module_type: 'ko',
	template: template
}
